import { render } from "./VenturesDescPage.vue?vue&type=template&id=a8c6983a"
import script from "./VenturesDescPage.vue?vue&type=script&lang=js"
export * from "./VenturesDescPage.vue?vue&type=script&lang=js"

import "./VenturesDescPage.vue?vue&type=style&index=0&id=a8c6983a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__